import { Injectable } from "@angular/core";
import { FileLogger } from "@comunicare/comunicare-helper";
import { IAppError, IReference, IVitalSignsHistory } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { Quantity } from "../models/quantity.model";
import { VitalSignApiService } from "./api/vital-sign-api.service";

@Injectable({
  providedIn: "root",
})
export class VitalSignService {
  constructor(private api: VitalSignApiService) {}

  public save(vitalSign: Quantity, patientReference: string, practitionerReference: IReference): Observable<unknown> {
    return this.api.save(vitalSign, patientReference, practitionerReference);
  }

  public list(patientReference: string): Observable<IVitalSignsHistory[]> {
    return this.api.list(patientReference);
  }

  public async exportVitalSigns(patientId: string, lang: string): Promise<void> {
    this.api.exportVitalSigns(patientId, lang).subscribe(
      (blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url);
      },
      (error: IAppError) => {
        FileLogger.error("VitalSignService", "exportVitalSigns", error);
        throw new Error(error.message);
      }
    );
  }
}
